import { Button as ChakraButton, useTheme } from '@chakra-ui/react';
import { useMemo } from 'react';

const ZaraButton = ({ variant, children, ...buttonProps }) => {
    const theme = useTheme();

    const typeButton = useMemo(
        () => ({
            blackAlpha: {
                fontSize: 'sm',
                bg: 'black',
                color: 'white',
                _hover: {
                    bg: '#18181be6',
                },
                _active: {
                    bg: '#18181be6',
                },
            },
            primary: {
                bg: '#5611F8',
                color: 'white',
                _hover: {
                    bg: '#450EC6',
                },
                _active: {
                    bg: '#370B9E',
                },
            },
            plus: {
                bg: 'linear-gradient(90.65deg, #5611F8 0.13%, #5611F8 0.13%, rgba(17, 193, 248, 0.65) 99.86%);',
                color: 'white',
            },
            enterprise: {
                bg: 'linear-gradient(90.65deg, #5611F8 0.13%, rgba(188, 17, 248, 0.65) 99.86%);',
                color: 'white',
            },
            secondary: {
                bg: '#EDF2F7',
                color: 'black',
                _hover: {
                    bg: 'gray.200',
                },
                _active: {
                    bg: 'gray.300',
                },
            },
            error: {
                bg: 'red.500',
                color: 'white',
                _hover: {
                    bg: 'red.500',
                    color: 'white',
                },
                _active: {
                    bg: 'red.500',
                    color: 'white',
                },
            },
            errorOutline: {
                border: `1px solid ${theme.colors.red[500]}`,
                bg: 'white',
                color: 'red.500',
                _hover: {
                    bg: 'red.500',
                    color: 'white',
                },
                _active: {
                    bg: 'red.500',
                    color: 'white',
                },
            },
            successOutline: {
                border: `1px solid ${theme.colors.green[500]}`,
                bg: 'white',
                color: 'green.500',
                _hover: {
                    bg: 'green.500',
                    color: 'white',
                },
                _active: {
                    bg: 'green.500',
                    color: 'white',
                },
            },

            settingsOutline: {
                border: `1px solid ${theme.colors.blue[500]}`,
                bg: 'white',
                color: 'blue.500',
                _hover: {
                    bg: 'blue.500',
                    color: 'white',
                },
                _active: {
                    bg: 'blue.500',
                    color: 'white',
                },
            },
        }),
        [theme.colors.blue, theme.colors.green, theme.colors.red]
    );
    return (
        <ChakraButton {...typeButton[variant ?? 'primary']} {...buttonProps}>
            {children}
        </ChakraButton>
    );
};

export default ZaraButton;
